export const ACCOUNT_CLOSED = 'CLOSED';
export const ACCOUNT_AUTH_PROHIBITED = 'AUTH_PROHIBITED';
export const WAIVED_INTEREST = 'WAIVED_INTEREST';
